import { UserPusherChannel } from '@ospin/pusher'
import addNotifications from '~/redux/pusher/userChannel/addNotifications'

const { EVENTS } = UserPusherChannel

export default userId => ({
  [EVENTS.USER_ADD_NOTIFICATIONS]: data => addNotifications(userId, data),
})
